class Experiment
{
  id: number;
  experiment_id: string;
  fiscal_year: number;
  experiment_number: number;
  caption: string;
  description_filepath: string;
  description_url: string;
  free_keywords: string;
  organization: string;
  staffs: string;
  completed_at: string;
  is_published: boolean;
  public_from: string;
  public_to: string;
  deleted: boolean;
  classification_id: number;
  img_src: string;

  constructor() {
    this.id = 0;
    this.experiment_id = '';
    this.experiment_number = 0;
    this.fiscal_year = 0;
    this.caption = '';
    this.description_filepath = '';
    this.description_url = '';
    this.free_keywords = '';
    this.organization = '';
    this.staffs = '';
    this.completed_at = '';
    this.is_published = false;
    this.public_from = '';
    this.public_to = '';
    this.deleted = false;
    this.classification_id = 0;
    this.img_src = '';
  }

  load(data: any) {
    this.id = data.id;
    this.experiment_id = data.experiment_id;
    this.experiment_number = data.experiment_number;
    this.fiscal_year = data.fiscal_year;
    this.caption = data.caption;
    this.description_filepath = data.description_filepath;
    this.description_url = data.description_url;
    this.free_keywords = data.free_keywords;
    this.organization = data.organization;
    this.staffs = data.staffs;
    this.completed_at = data.completed_at;
    this.is_published = data.is_published;
    this.public_from = data.public_from;
    this.public_to = data.public_to;
    this.deleted = data.deleted;
    this.classification_id = data.classification_id;
    this.img_src = data.img_src;
  }

  buildFormData(): FormData {
    const data = new FormData();

    data.append('id', this.id.toString());
    data.append('experiment_id', this.experiment_id);
    data.append('experiment_number', this.experiment_number.toString());
    data.append('fiscal_year', this.fiscal_year.toString());
    data.append('caption', this.caption);
    data.append('description_filepath', this.description_filepath);
    data.append('description_url', this.description_url);
    data.append('free_keywords', this.free_keywords);
    data.append('organization', this.organization);
    data.append('staffs', this.staffs);
    data.append('completed_at', this.completed_at);
    data.append('is_published', this.is_published.toString());
    data.append('public_from', this.public_from);
    data.append('public_to', this.public_to);
    data.append('deleted', this.deleted.toString());
    data.append('classification_id', this.classification_id.toString());
    data.append('img_src', this.img_src);

    return data;
  }
}

export default Experiment;
